import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=1372a2fc&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"
import style0 from "./mobile.vue?vue&type=style&index=0&id=1372a2fc&prod&lang=scss&scoped=true"
import style1 from "./mobile.vue?vue&type=style&index=1&id=1372a2fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372a2fc",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/examintro/mobile.vue
// module id = null
// module chunks = 